'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Modal = undefined;

var _components = require('@rebass/components');

var _components2 = _interopRequireDefault(_components);

var _styledSystem = require('styled-system');

var _index = require('./index');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Modal = exports.Modal = (0, _components2.default)({
  extend: _index.Fixed,
  top: '50%',
  left: '50%',
  p: 3,
  bg: 'white',
  borderRadius: 2,
  maxWidth: '100vw',
  maxHeight: '100vh'
}, function (props) {
  return {
    boxShadow: '0 0 0 60vmax ' + (0, _styledSystem.themeGet)('colors.darken')(props) + ', 0 0 32px ' + (0, _styledSystem.themeGet)('colors.darken')(props),
    overflow: 'auto',
    transform: 'translate(-50%, -50%)'
  };
}, 'borderRadius', 'width', 'maxWidth', 'maxHeight');
Modal.displayName = 'Modal';

exports.default = Modal;


//////////////////
// WEBPACK FOOTER
// ./~/rebass/dist/Modal.js
// module id = 2086
// module chunks = 168707334958949